<div class="spinner-wrapper">
   <div
      style="background-size: 100%"
      class="bg-project-spinner w-[128px] h-[128px] spinner-logo"
   ></div>
</div>
